export default "__VITE_ASSET__5NILYyYh__"